import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "inputs" }
const _hoisted_2 = {
  class: "card bg-white mb-3",
  style: {"width":"100%","border-radius":"10px"}
}
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = { class: "table table-bordered" }
const _hoisted_5 = {
  style: {"background":"#dee2e6"},
  scope: "col"
}
const _hoisted_6 = {
  class: "ml-5",
  style: {"display":"flex","justify-content":"left"}
}
const _hoisted_7 = { class: "ml-5 pl-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropdownComp = _resolveComponent("DropdownComp")!
  const _component_GridLoading = _resolveComponent("GridLoading")!
  const _component_ShadingComponent = _resolveComponent("ShadingComponent")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createBlock(_component_Accordion, {
    Heading: _ctx.shadeGrouping,
    Title1: _ctx.defaultColor,
    Value1: _ctx.selectedDefaultColor,
    options: _ctx.options,
    Title3: _ctx.shadeConfiguration,
    isEnable: _ctx.isEnable
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("table", _hoisted_4, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    _createVNode(_component_DropdownComp, {
                      options: _ctx.options,
                      onToggleEventChange: _ctx.toggleEvent,
                      toggleButtonVal: _ctx.toggleButtonValue,
                      selectedDefaultColor: _ctx.selectedDefaultColor,
                      onChangeDefaultColorSelectorValue: _ctx.changeDefaultColorSelectorValue
                    }, null, 8, ["options", "onToggleEventChange", "toggleButtonVal", "selectedDefaultColor", "onChangeDefaultColorSelectorValue"])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, _toDisplayString(_ctx.$t("shadeGrouping.colors")), 1),
                      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("shadeGrouping.shades")), 1)
                    ])
                  ])
                ]),
                _createElementVNode("tr", null, [
                  _createElementVNode("td", null, [
                    (_ctx.showLoader)
                      ? (_openBlock(), _createBlock(_component_GridLoading, { key: 0 }))
                      : (_openBlock(), _createBlock(_component_ShadingComponent, {
                          key: 1,
                          options: _ctx.options,
                          inputData: _ctx.inputData,
                          onHandleRemoveShade: _ctx.handleRemoveShade,
                          onHandleAddShade: _ctx.handleAddShade,
                          onGetShadeName: _ctx.getShadeName,
                          onGetShadeValue: _ctx.getShadeValue,
                          onHandleUpdate: _ctx.handleUpdate,
                          onEditShade: _ctx.editShade,
                          isActive: _ctx.toggleButtonValue
                        }, null, 8, ["options", "inputData", "onHandleRemoveShade", "onHandleAddShade", "onGetShadeName", "onGetShadeValue", "onHandleUpdate", "onEditShade", "isActive"]))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["Heading", "Title1", "Value1", "options", "Title3", "isEnable"]))
}